import { RemoteDuplicateDiscount } from '../../../data/usecases/duplicate-discount/duplicate-discount'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeRemoteDuplicateDiscount = ():any => new RemoteDuplicateDiscount('/descontoduplicata', makeAxiosHttpClient())

export const makeRemoteDuplicateDiscountExport = ():any => new RemoteDuplicateDiscount('/descontoduplicata/export', makeAxiosHttpClient())

export const makeRemoteDuplicateDiscountBaixar = ():any => new RemoteDuplicateDiscount('/descontoduplicata/baixar', makeAxiosHttpClient())
